import React from "react"
import Layout from "../layout/Layout"
import SEO from "../components/seo"
import Hero from "../components/Hero/Hero"
import MainOfferSection from "../components/MainOfferSection/MainOfferSection"
import MainOfferList from "../components/MainOfferList/MainOfferList"
import MainTrackingSection from "../components/MainTrackingSection/MainTrackingSection"
import ScrollAnimation from "react-animate-on-scroll"

const IndexPage = () => (
  <Layout>
    <SEO title="Kierownik budowy Recz" ratingCount={21} ratingValue={4.8} />
    <Hero />
    <ScrollAnimation animateIn="fadeIn">
      <MainOfferSection />
    </ScrollAnimation>
    <ScrollAnimation animateIn="fadeIn">
      <MainOfferList />
    </ScrollAnimation>
    <ScrollAnimation animateIn="fadeIn">
      <MainTrackingSection />
    </ScrollAnimation>
  </Layout>
)

export default IndexPage
